import React, { useState } from "react";
import { Autocomplete } from "@react-google-maps/api";
import { fieldClass } from "../assets/classes/fieldClasses";
import FormikInput from "./FormikFieldCustom";
const GooglePlacesAutoComplete = ({
  setFieldValue,
}: {
  setFieldValue: any;
}) => {
  const [autocomplete, setAutocomplete] = useState<any>(null);

  const onLoad = (autocomplete: any) => {
    autocomplete.setComponentRestrictions({ country: "us" });
    setAutocomplete(autocomplete);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place && place.formatted_address) {
        const addressComponents = place.address_components || [];
        let address = "";
        let city = "";
        let state = "";
        let zipCode = "";
        let country = "";
        addressComponents.forEach((component: any) => {
          if (
            component.types.includes("street_number") ||
            component.types.includes("route")
          ) {
            address += component.long_name + " ";
          }
          if (!address) {
            if (
              component.types.includes("premise") ||
              component.types.includes("sublocality_level_1") ||
              component.types.includes("sublocality") ||
              component.includes("political")
            ) {
              address += component.long_name;
              address += component.short_name;
            }
          }
          if (component.types.includes("locality")) {
            city = component.long_name;
          }
          if (
            component.types.includes("administrative_area_level_1") ||
            component.types.includes("administrative_area_level_2")
          ) {
            state = component.short_name;
          }
          if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          }
          if (component.types.includes("country")) {
            country = component.long_name;
          }
        });
        setFieldValue("address", address);
        setFieldValue("city", city);
        setFieldValue("state", state);
        setFieldValue("zip", zipCode);
        setFieldValue("country", country);
      } else {
        console.log("Address information not found.");
      }
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Autocomplete
      options={{ types: ["address"] }}
      onLoad={onLoad}
      onPlaceChanged={onPlaceChanged}
    >
      <FormikInput
        name="address"
        onKeyDown={handleKeyDown}
        className={fieldClass}
        type="text"
        placeholder="Enter address"
      />
    </Autocomplete>
  );
};

export default GooglePlacesAutoComplete;
